<template>
  <inventoryProductsForm :typeEndPoint="'papeleriaProductsShow'" :dataParams="this.$route.params" />
</template>
<script>
import inventoryProductsForm from '@/components/modules/papeleria/products/form'
export default {
  name: 'inventoryProductsEdit',
  components: {
    inventoryProductsForm
  },
  mounted () {
    console.log(this.$route.params)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/papeleria/products/edit.vue